<template>
  <div class="content">
    <div class="iconWrapper">
      <i class="icon bi bi-arrow-repeat" />
    </div>
    <div class="title">{{ $t("game.preGameModalWaitingProgress.title") }}</div>
    <div class="text">{{ $t("game.preGameModalWaitingProgress.text") }}</div>
    <div class="progress-bar-container">
      <div class="bar">
        <div class="progress" :style="`width: ${loadingProgress}%;`" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.content {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;

  .iconWrapper {
    width: 64px;
    height: 64px;

    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    font-size: 36px;

    background-color: #1fa969;

    .icon {
      animation: spinner 1.5s linear infinite;

      @keyframes spinner {
        to {
          transform: rotate(360deg);
        }
      }
    }
  }

  .title {
    font-size: 32px;
    font-weight: 700;

    @media screen and (max-width: $small-screen) {
      font-size: 20px;
    }

    margin-top: 8px;
    margin-bottom: 48px;

    @media (orientation: "landscape") {
      margin-bottom: 18px;
    }
    text-align: center;
  }

  .text {
    font-size: 16px;

    @media screen and (max-width: $small-screen) {
      font-size: 14px;
    }

    margin-bottom: 24px;
    text-align: center;
  }

  .progress-bar-container {
    height: 4px;

    .bar {
      height: 100%;
      background-color: #ffffff33;

      .progress {
        height: 100%;
      }
    }
  }
}
</style>

<script setup lang="ts">
defineProps({
  loadingProgress: {
    type: Number,
    required: true,
  },
});
</script>
